import React from "react";
import { Link } from "@reach/router";
import styles from "./FolkSummary.module.scss";
import MammalChampion from "./MammalChampion";
import InsectChampion from "./InsectChampion";
import PlantChampion from "./PlantChampion";
import GeographyChampion from "./GeographyChampion";
// import EColiChampion from "./NPCs/EColi";
import BirdChampion from "./BirdChampion";
import LiverBird from "./LiverBird";

function FolkSummary(props) {
  return (
    <div className={styles.message}>
      {props.type.name === "mammal" ? (
        <MammalChampion type={props.type.name} alpha={props.alpha} />
      ) : props.type.name === "insect" ? (
        <InsectChampion type={props.type.name} alpha={props.alpha} />
      ) : props.type.name === "plant" ? (
        <PlantChampion type={props.type.name} alpha={props.alpha} />
      ) : props.type.name === "natural feature" ? (
        <GeographyChampion type={props.type.name} alpha={props.alpha} />
      ) : // props.type.name === "bacteria" ? (
      //   <EColiChampion type={props.type.name} />
      // ) :
      props.type.name === "bird" ? (
        <BirdChampion type={props.type.name} alpha={props.alpha} />
      ) : props.type.name === "Liverbird" ? (
        <LiverBird type={props.type.name} alpha={props.alpha} />
      ) : null}
    </div>
    // <div className={styles.message}>
    //   {props.type.name === "bird" ? (
    //     <p>Bird is the word</p>
    //   ) : props.type.name === "water" ? (
    //     <p>you are water, rushing cool refreshing</p>
    //   ) : props.type.name === "mammal" ? (
    //     <p>what does the fox say</p>
    //   ) : (
    //     <p></p>
    //   )}
    //   <p>Yes! I want to be one of the {props.type.name} folk!</p>
    //   <h3>
    //     <Link to={"/" + props.type.name + ""}>E N T E R </Link>
    //   </h3>
    // </div>
  );
}

export default FolkSummary;
